import {MoviesObj} from 'common/src/modules/movieEditor/movieEditor.types';

const DEFAULT_MAX_HISTORY_LENGTH = 20;
const HISTORY_DEBOUNCE_INTERVAL = 1000;

const backHistory = {
  state: [] as MoviesObj[],
};

const forwardHistory = {
  state: [] as MoviesObj[],
};

let lastAppendTime = 0;
let pendingAppend: MoviesObj | null = null;
let appendTimeout: NodeJS.Timeout | null = null;

const appendStateToBackHistory = (value: MoviesObj) => {
  const now = Date.now();

  if (now - lastAppendTime < HISTORY_DEBOUNCE_INTERVAL) {
    pendingAppend = value;

    if (appendTimeout) {
      clearTimeout(appendTimeout);
    }

    appendTimeout = setTimeout(
      () => {
        if (pendingAppend) {
          backHistory.state.push(pendingAppend);

          if (backHistory.state.length > DEFAULT_MAX_HISTORY_LENGTH) {
            backHistory.state = backHistory.state.slice(-DEFAULT_MAX_HISTORY_LENGTH);
          }

          pendingAppend = null;
          lastAppendTime = Date.now();
        }
      },
      HISTORY_DEBOUNCE_INTERVAL - (now - lastAppendTime),
    );

    return;
  }

  backHistory.state.push(value);

  if (backHistory.state.length > DEFAULT_MAX_HISTORY_LENGTH) {
    backHistory.state = backHistory.state.slice(-DEFAULT_MAX_HISTORY_LENGTH);
  }

  lastAppendTime = now;
};

function pushMovieCompsHistory(oldMovies: MoviesObj) {
  appendStateToBackHistory(oldMovies);
  forwardHistory.state = [];
}

function backMovieCompsHistory(currentMovies: MoviesObj): MoviesObj | null {
  if (!backHistory.state.length) return null;

  forwardHistory.state.push(currentMovies);

  return backHistory.state.pop() || null;
}

function forwardMovieCompsHistory(currentMovies: MoviesObj): MoviesObj | null {
  if (!forwardHistory.state.length) return null;

  backHistory.state.push(currentMovies);
  const nextState = forwardHistory.state.pop();

  return nextState || null;
}

function resetMovieCompsHistory() {
  backHistory.state = [];
  forwardHistory.state = [];

  if (appendTimeout) {
    clearTimeout(appendTimeout);
    appendTimeout = null;
  }

  pendingAppend = null;
  lastAppendTime = 0;
}

function clearMovieCompsHistory() {
  backHistory.state = [];
  forwardHistory.state = [];
}

export const movieCompsHistoryActions = {
  push: pushMovieCompsHistory,
  back: backMovieCompsHistory,
  forward: forwardMovieCompsHistory,
  resetHistory: resetMovieCompsHistory,
  clear: clearMovieCompsHistory,
  backHistory: backHistory,
  forwardHistory: forwardHistory,
};
